(function ($) {
	$(function () {
		// $('.pager a').click(function() {
		// 	$('html, body').animate({
		// 		scrollTop: $($(this).attr('href')).offset().top + 'px'
		// 	}, {
		// 		duration: 700
		// 	});
		// 	return false;
		// });
		$('body').on('submit', '.ajax_form', function(ev) {
			ev.preventDefault();
			var data = $(this).serialize();
			var form = $(this);
			$.ajax({
					type: 'POST',
					url: '/ajax/',
					dataType: 'json',
					data: data
				})
				.done(function(msg) {
					if ($(form).attr('id') == 'order_form') {
						$(form).prev().remove();
						setTimeout(function() {
							if ($('.f_window').is(':visible')) {
								$('.f_window').find('.close_button').click();
							}
						}, 5000);
					}
					$(form).next().show();
					$(form).remove();
				});
		});
	});
})(jQuery);